import { SharedState, useSharedState } from '@trello/shared-state';

export const wasShowSidebarSpotlightViewedState = new SharedState<boolean>(
  false,
);

export const useWasShowSidebarSpotlightViewed = () => {
  const [wasShowSidebarSpotlightViewed] = useSharedState(
    wasShowSidebarSpotlightViewedState,
  );
  return wasShowSidebarSpotlightViewed;
};
